import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { BusinessDetailsService, SharedService } from './core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'Glamera Registration';

  /** false until getRegisteredPhases completes; then show router-outlet */
  phasesCheckDone = false;

  constructor(
    private readonly spinner: NgxSpinnerService,
    private readonly businessDetailsService: BusinessDetailsService,
    private readonly sharedService: SharedService,
    private readonly route: ActivatedRoute,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    if (!localStorage.getItem('lang')) {
      localStorage.setItem('lang', 'ar');
    }
    if (!localStorage.getItem('dir')) {
      localStorage.setItem('dir', 'rtl');
    }

    this.spinner.show();
    this.loadRegisteredPhases();
  }

  /**
   * Loads registered phases; on success:
   * - If Result has One, Two, Three but not Four → redirect to choose-business?RegistrationCycleLogId=...
   * - If Result has One, Two, Three, Four → redirect to smart-suggestions/:RegistrationCycleLogId
   * Spinner and no content until response returns.
   */
  private loadRegisteredPhases(): void {
    const params = this.route.snapshot.queryParams;
    const regIdFromUrl = params['RegistrationCycleLogId'];
    const regId =
      regIdFromUrl ?? this.sharedService.getLocalStorage('RegistrationCycleLogId');

    const done = (): void => {
      this.phasesCheckDone = true;
      this.spinner.hide();
    };

    if (!regId) {
      done();
      return;
    }

    if (regIdFromUrl) {
      this.sharedService.setLocalStorage('RegistrationCycleLogId', String(regIdFromUrl));
    }

    this.businessDetailsService
      .getRegisteredPhases({ RegistrationCycleLogId: +regId })
      .subscribe({
        next: (res) => {
          const result = res?.Result;
          if (!result) {
            done();
            return;
          }

          const hasOne = !!result.One;
          const hasTwo = !!result.Two;
          const hasThree = !!result.Three;
          const hasFour = !!result.Four;
          const registrationCycleLogId = result.RegistrationCycleLogId;

          if (hasOne && hasTwo && hasThree && hasFour) {
            this.router.navigate(['smart-suggestions', registrationCycleLogId]);
          } else if (hasOne && hasTwo && !hasFour) {
            // One+Two only, or One+Two+Three (working hours not done)
            this.router.navigate(['choose-business'], {
              queryParams: { RegistrationCycleLogId: registrationCycleLogId },
            });
          }

          done();
        },
        error: () => {
          done();
        },
      });
  }
}
